import gql from 'graphql-tag';

export const ARTICLES_FROM_ARTICLE_GROUP_QUERY = gql`
  query ArticlesFromArticleGroupQuery($id: ID!) {
    articleGroup(id: $id) {
      articles {
        id
        deprecated
        campaign {
          id
          name
          flipperFeatures {
            name
            enabled
          }
          publisher {
            id
            name
          }
          useCase
        }
      }
    }
  }
`;
